import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/lotesdashboard",
    name: "LotesDashboard",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Dashboard.vue"),
	},
	{
    path: "/lotes",
    name: "Lotes",
    beforeEnter: routeGuard,
    component: () => import("../views/Lotes.vue"),
    children: [
      {
        path: ":numero",
        component: () => import("../views/Lotes.vue"),
      }
    ]
  }
];
